import React from "react";
import { Redirect, Route } from "react-router-dom";
import jwtDecode from "jwt-decode";

import { URI_PATHS } from "../../../../constants";

const jwtExpired = (jwt) => {
  let decodedJwt;
  try{
    decodedJwt = jwtDecode(jwt);
  } catch(err) {
    localStorage.removeItem("jwt");
    return true;
  }
  const now = Date.now().valueOf() / 1000;    // Today's date in POSIX
  const { exp: expirationDate } = decodedJwt;

  if(!expirationDate || expirationDate < now){
    localStorage.removeItem("jwt");
    return true;
  }

  return false;
};

const PrivateRoute = ({ ...routeComponentProps }) => {
  const jwt = window.localStorage.getItem("jwt");

  if(!jwt || jwtExpired(jwt))
    return <Redirect to={URI_PATHS.LOGIN} />;

  // Ignore linter error here since this component is supposed to be a wrapper so we
  // should forward every prop possible
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Route {...routeComponentProps} />;
};

export default PrivateRoute;